import type { MediaAttachment } from "@uri/abstract-bot-api";
import { apiClient, httpCommunication } from "@uri/typed-api";
import { apiDefinition } from "./apiTyping.ts";

export type SupergreenWebhookUpdate = {
  network: "whatsapp" | "telegram";
  chat: { id: string; username?: string; title?: string };
  author: { id: string; username?: string };
  text: string;
  attachments?: MediaAttachment[];
  time: number;
};

export const apiBaseUrl = "https://api.supergreen.cc";

export default apiClient(httpCommunication(apiBaseUrl), apiDefinition);
